import React from 'react';
import {Markdown} from 'react-showdown';
import AspectRatioImage from '../AspectRatioImage/AspectRatioImage';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';

const FeaturedArticle = ({
    headline,
    parent,
    heroFile,
    overview,
    path,
    homeRoute,
    isDevice,
}) => {
    const link = homeRoute + path;
    const firstSentence = overview && overview.match(/[^\.!\?]+[\.!\?]+/g)[0];
    return (
        <div className="FeaturedArticle">
            {heroFile && heroFile.url && (
                <AspectRatioImage
                    className="FeaturedArticle__top"
                    linkComponent={(children) => (
                        <Link to={link}>{children}</Link>
                    )}
                    {...heroFile}
                />
            )}
            <div className="FeaturedArticle__bottom">
                <h3 className="FeaturedArticle__heading">
                    <Link to={link}>
                        <span className="heading-hover-bg">{headline}</span>
                    </Link>
                </h3>
                <p className="FeaturedArticle__subheading">
                    <Link to={homeRoute + parent.path}>
                        <strong>{parent.name}</strong>
                    </Link>
                </p>
                {!isDevice && <Markdown markup={firstSentence} />}
            </div>
        </div>
    );
};

FeaturedArticle.propTypes = {
    headline: PropTypes.string.isRequired,
    parent: PropTypes.objectOf(PropTypes.string.isRequired),
    heroFile: PropTypes.objectOf(PropTypes.string),
    overview: PropTypes.string,
    path: PropTypes.string.isRequired,
    homeRoute: PropTypes.string.isRequired,
};

export default FeaturedArticle;
